"use client";

import React from "react";
import { SingularJob } from "@/lib/types";
import {
  DDG,
  Cosmic,
  Moneybox,
  HomeHero,
  NeuerEnergy,
  Cognite,
  Incuna,
  Apple,
} from "@/components/icons/companies";

interface JobListItemProps {
  company: SingularJob;
  compact?: boolean;
}

const JobListItem: React.FC<JobListItemProps> = ({
  company,
  compact = false,
}) => {
  function getCompanyIcon(company: string) {
    switch (company.toLowerCase()) {
      case "duckduckgo":
        return <DDG className="size-8 shrink-0" />;
      case "cosmic":
        return <Cosmic className="size-6 shrink-0" />;
      case "moneybox":
        return (
          <Moneybox className="text-foreground-200 size-8 shrink-0 dark:fill-teal-950" />
        );
      case "homehero":
        return (
          <HomeHero className="size-8 shrink-0 fill-[#312DBC] text-white" />
        );
      case "neuerenergy":
        return <NeuerEnergy className="size-8 shrink-0" />;
      case "cognite":
        return <Cognite className="size-8 shrink-0" />;
      case "incuna":
        return <Incuna className="size-8 shrink-0" />;
      case "apple retail":
        return <Apple className="size-8 shrink-0 text-inherit" />;
      default:
        return null;
    }
  }

  return (
    <li
      className={`flex items-center space-x-2 ${
        company.metadata.is_contract && !compact
          ? "border-foreground-300 ml-4 border-l pr-4 pl-8"
          : ""
      } w-full`}
    >
      {getCompanyIcon(company.metadata.company)}
      <span className="text-foreground-700 w-max text-lg font-medium whitespace-nowrap">
        {company.metadata.url != null && !compact ? (
          <a
            href={company.metadata.url}
            target="_blank"
            rel="noreferrer"
            className="text-foreground decoration-foreground underline decoration-2 underline-offset-4"
          >
            {company.metadata.company} ↗
          </a>
        ) : (
          <span className="text-foreground-700 w-max text-lg font-medium whitespace-nowrap">
            {company.metadata.company}
          </span>
        )}
      </span>
      {!compact && (
        <>
          <hr className="border-foreground-300 my-auto w-full border-dashed" />
          <span className="flex w-max justify-end text-right text-sm whitespace-nowrap text-neutral-600 dark:text-neutral-400">
            {company.metadata.date_range}
          </span>
        </>
      )}
    </li>
  );
};

export default JobListItem;
